import React from 'react';

const Logotype = (props) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 657.13 112.44"
      className={`logo ${props.halfPage ? 'half-page' : ''} ${
        props.color
      }`}
    >
      <defs></defs>
      <title>Cloud Nine Logotype</title>
      <g id="_Group_" data-name="&lt;Group&gt;">
        <path
          id="_Compound_Path_"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M631.27,13.92a11.71,11.71,0,1,1-11.7,11.71,11.7,11.7,0,0,1,11.7-11.71m0-12.54a24.25,24.25,0,1,0,24.24,24.25A24.27,24.27,0,0,0,631.27,1.38Z"
        />
        <path
          id="_Compound_Path_2"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M39.1,48.78A14.27,14.27,0,0,0,31,51a17.57,17.57,0,0,0-5.34,5.7,24.58,24.58,0,0,0-2.92,7.69,41.8,41.8,0,0,0-.86,8.34,40,40,0,0,0,.86,8.12,25.11,25.11,0,0,0,2.78,7.48,15.88,15.88,0,0,0,5.2,5.49,14.31,14.31,0,0,0,8,2.14q7.26,0,11.19-4.06A19.22,19.22,0,0,0,54.77,81H74.29q-2,14.68-11.4,22.38t-24.08,7.69a40.2,40.2,0,0,1-15.18-2.78,33.71,33.71,0,0,1-11.75-7.76,35.31,35.31,0,0,1-7.55-11.9A41.19,41.19,0,0,1,1.62,73.43,49.19,49.19,0,0,1,4.11,57.54a35.7,35.7,0,0,1,7.34-12.68,33.66,33.66,0,0,1,11.83-8.34,40.24,40.24,0,0,1,16-3,46.19,46.19,0,0,1,12.61,1.71,33.56,33.56,0,0,1,10.83,5.2,26.87,26.87,0,0,1,11.19,21H54.06Q52.07,48.79,39.1,48.78Z"
        />
        <path
          id="_Compound_Path_3"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M100.8,13.85V109.2H80.56V15.4Z"
        />
        <path
          id="_Compound_Path_4"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M111.49,56.4a33.69,33.69,0,0,1,19.66-20.09,42.12,42.12,0,0,1,15.68-2.78,42.66,42.66,0,0,1,15.74,2.78A33.6,33.6,0,0,1,182.31,56.4a45.34,45.34,0,0,1,2.71,16,44.71,44.71,0,0,1-2.71,16,34.55,34.55,0,0,1-7.7,12.19,33.38,33.38,0,0,1-12,7.76,43.51,43.51,0,0,1-15.74,2.71,43,43,0,0,1-15.68-2.71,33.7,33.7,0,0,1-12-7.76,34.39,34.39,0,0,1-7.69-12.19,44.49,44.49,0,0,1-2.71-16A45.12,45.12,0,0,1,111.49,56.4Zm18.38,24.66a22.9,22.9,0,0,0,2.92,7.55A15.6,15.6,0,0,0,138.28,94a16.75,16.75,0,0,0,8.55,2,17.15,17.15,0,0,0,8.62-2A15.48,15.48,0,0,0,161,88.61a23.12,23.12,0,0,0,2.92-7.55,43.25,43.25,0,0,0,.85-8.63,44.22,44.22,0,0,0-.85-8.69A22.36,22.36,0,0,0,161,56.19a16.29,16.29,0,0,0-5.56-5.35,16.74,16.74,0,0,0-8.62-2.06,15.54,15.54,0,0,0-14,7.41,22.15,22.15,0,0,0-2.92,7.55,44.23,44.23,0,0,0-.86,8.69A43.25,43.25,0,0,0,129.87,81.06Z"
        />
        <path
          id="_Compound_Path_5"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M242.3,109.2V98.94h-.43a22.78,22.78,0,0,1-10,9.26,29.47,29.47,0,0,1-12.54,2.85A35.32,35.32,0,0,1,206,108.91a19.26,19.26,0,0,1-8.19-6,23.69,23.69,0,0,1-4.2-9.55,59.21,59.21,0,0,1-1.21-12.47V35.53h20.23V77.14q0,9.12,2.85,13.6t10.12,4.49q8.26,0,12-4.91t3.7-16.18V35.53h20.24V109.2Z"
        />
        <path
          id="_Compound_Path_6"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M323.53,99.79a20.93,20.93,0,0,1-9.34,8.63,31.12,31.12,0,0,1-13,2.63,31.57,31.57,0,0,1-14.53-3.2,29.13,29.13,0,0,1-10.33-8.7,39.37,39.37,0,0,1-6.13-12.61,52.85,52.85,0,0,1-2.07-14.82,49.65,49.65,0,0,1,2.07-14.32,37.13,37.13,0,0,1,6.13-12.18,29.76,29.76,0,0,1,24.44-11.69,29,29,0,0,1,12.46,2.78,21.67,21.67,0,0,1,9.34,8.19h.28V15.4l20.24-1.55V109.2H323.81V99.79Zm-.86-36.4A21.38,21.38,0,0,0,319.75,56a16.58,16.58,0,0,0-5.34-5.2,15.68,15.68,0,0,0-8.27-2,16.44,16.44,0,0,0-8.41,2,15.67,15.67,0,0,0-5.48,5.28,23.28,23.28,0,0,0-3,7.48,41,41,0,0,0-.92,8.76,37.24,37.24,0,0,0,1,8.55,23.39,23.39,0,0,0,3.2,7.63,17.82,17.82,0,0,0,5.56,5.41A15,15,0,0,0,306.14,96a16.07,16.07,0,0,0,8.34-2,15.17,15.17,0,0,0,5.34-5.34A24,24,0,0,0,322.67,81a44.9,44.9,0,0,0,.86-8.83A43.82,43.82,0,0,0,322.67,63.39Z"
        />
        <path
          id="_Compound_Path_7"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M371.83,35.53V45.79h.43a23.23,23.23,0,0,1,10-9.34,28.92,28.92,0,0,1,12.54-2.92,34.42,34.42,0,0,1,13.32,2.21,19.61,19.61,0,0,1,8.19,6.13,23.65,23.65,0,0,1,4.21,9.54,60,60,0,0,1,1.21,12.47V109.2H401.47V67.59q0-9.12-2.85-13.61t-10.11-4.49q-8.26,0-12,4.92t-3.71,16.17V109.2H352.6V35.53Z"
        />
        <path
          id="_Compound_Path_8"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M452.2,35.53V109.2H432V35.53Z"
        />
        <path
          id="_Compound_Path_9"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M483.15,35.53V45.79h.43a23.21,23.21,0,0,1,10-9.34,29,29,0,0,1,12.54-2.92,34.44,34.44,0,0,1,13.33,2.21,19.74,19.74,0,0,1,8.19,6.13,23.64,23.64,0,0,1,4.2,9.54A59.28,59.28,0,0,1,533,63.88V109.2H512.79V67.59q0-9.12-2.85-13.61t-10.12-4.49q-8.26,0-12,4.92t-3.7,16.17V109.2H463.91V35.53Z"
        />
        <path
          id="_Compound_Path_10"
          data-name="&lt;Compound Path&gt;"
          className="cls-1"
          d="M564,91.53q4.56,4.41,13.11,4.42a18,18,0,0,0,10.55-3.07c2.94-2,4.75-4.2,5.41-6.48H610.9q-4.27,13.25-13.11,18.95t-21.38,5.7a41.9,41.9,0,0,1-15.67-2.78,32.53,32.53,0,0,1-11.83-7.91,35.46,35.46,0,0,1-7.48-12.25,44.83,44.83,0,0,1-2.64-15.68A42.86,42.86,0,0,1,541.5,57a35.63,35.63,0,0,1,19.59-20.52,38.24,38.24,0,0,1,15.32-3,35.09,35.09,0,0,1,16.39,3.63,32.77,32.77,0,0,1,11.47,9.77,40.13,40.13,0,0,1,6.48,14,52,52,0,0,1,1.43,16.39H559Q559.45,87.1,564,91.53Zm22.88-38.76q-3.64-4-11-4a17.64,17.64,0,0,0-8.05,1.64,15.18,15.18,0,0,0-5.13,4.06A14.8,14.8,0,0,0,560,59.61a23,23,0,0,0-.92,4.84h32.91Q590.52,56.76,586.89,52.77Z"
        />
      </g>
    </svg>
  );
};

export default Logotype;
